import { render, staticRenderFns } from "./AppCustomFieldInput.vue?vue&type=template&id=5cd28b0b&"
import script from "./AppCustomFieldInput.vue?vue&type=script&lang=js&"
export * from "./AppCustomFieldInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports